<template>
  <span>
    ({{ listCount }})
  </span>
</template>
<script type="text/ecmascript-6">

export default {
  name: 'FouSpan',

  props: {
    listCount: {
      type: Number,
      default: 0
    }
  }
}
</script>
